
import webService from "@network/webService";
export default {
    commonInfoEnmus: {
        //职能
        Responsibility: 'responsibility',
        //级别
        Title: 'title',
        //关系深度
        RelationDeepth: 'relationDeepth',
        //行业
        Industry: 'industry',
        //阶段
        InvestmentPreference: 'investmentPreference',
        //类型 
        InvestmentType: 'investmentType',
        //国家
        Country: 'country',
        //轮次
        // InvestmentRound: 'investmentRound',
        //最新获投
        // LatestInvestment: 'latestInvestment',
        //机构主投阶段
        OrgStage: 'orgStage',
        //机构主投领域
        OrgIndustry: 'orgIndustry',
        //公司行业领域
        CompanyIndustry: 'companyIndustry',
        //公司轮次
        CompanyRound: 'companyRound',
        //公司最新获投
        CompanyInvestmentDate: 'companyInvestmentDate',
        //新闻模块
        NewsType: 'newsType',
        MarketPeriod: 'marketPeriod',
        exitIPO: 'exitIPO',
        exitSales: 'exitSales',
        stockExchange: 'stockExchange',
        dates: 'dates',
        //专注行业
        userIndustry: 'userIndustry',
    },
    relationshipSearchTypeEnum: {
        PEOrganization: 1,
        PEContact: 2,
        Invested: 3,
    },
    searchTypeEnum: {
        org: 1,
        orgCollect: 2,
        contractor: 3,
        contractorCollect: 4,
        invested: 5,
        investedCollect: 6,
        relation: 7,
        relationCollect: 8,

        contractorCompany: 9,
        contractorCompanyCollect: 10,


        orgHistory: 11,
        contractorHistory: 12,
        investedHistory: 13,
        relationHistory: 14,
        contractorCompanyHistory: 15,
        newsHistory: 16,

        newsType: 21,
        marketPeriod: 22,
        newsTypeCollect: 23,

        exitIPO: 30,
        exitIPO2: 35,
        exitSales: 31,

        orgInvestedCompany: 100, //机构详情页中的已投公司
        orgListFunding1: 101,//
        orgListFunding2: 102,//
        orgListFunding3: 103,//
        onlyDates: 110,
    },
    favoriteTypeEnum:
    {
        Relationship: 1,
        Organization: 2,
        OrgContact: 3,
        InvestedCompany: 4,
        CompanyContact: 5,
        News: 6,
        NewsMarket: 7,
    },
    searchHistoryTypeEnum: {
        Organization: 1,
        Company: 2,
        Relationship: 3,
    },
    ellipsis (_val, len) {
        if (!len) {
            len = 21;
        }
        if (!_val) return "";
        if (_val.length > len) {
            return _val.slice(0, len) + "...";
        }
        return _val;
    },
    resetTabs () {
        sessionStorage.setItem("_active", 0);
        sessionStorage.setItem("_pageType", this.searchTypeEnum.relationCollect);

        sessionStorage.setItem("_activeHistory", 0);
        sessionStorage.setItem("_pageTypeHistory", this.searchTypeEnum.relationHistory);


    },
    procssData (_vm, dataList, isAdd) {
        let pos = _vm.list.length;
        if (isAdd != undefined) {
            _vm.list = dataList;
        }
        else {
            for (let i = 0; i < dataList.length; i++) {
                _vm.$set(_vm.list, pos, dataList[i]);
                pos++;
            }
        }
        // Array.prototype.push.apply(_vm.list, dataList);
        _vm.loading = false;
        if (dataList.length <= 0) {
            _vm.finished = true;
        }
        else {
            _vm.finished = false;
        }
        _vm.currentPage++;
    },
    procssData_collect (_vm, dataList) {
        let pos = _vm.list.length;
        for (let i = 0; i < dataList.length; i++) {
            dataList[i].checked = false;
            _vm.$set(_vm.list, pos, dataList[i]);
            pos++;
        }
        _vm.loading = false;
        _vm.finished = true;//收藏不分页，直接结束加载
        // if (dataList.length <= 0) {
        //     _vm.finished = true;
        // }

        // _vm.currentPage++;
    },
    procssData_collect_relation (_vm, dataList) {
        let pos = _vm.itemList.length;
        for (let i = 0; i < dataList.length; i++) {
            dataList[i].checked = false;
            _vm.$set(_vm.itemList, pos, dataList[i]);
            pos++;
        }
        _vm.loading = false;
        _vm.finished = true;//收藏不分页，直接结束加载
        // if (dataList.length <= 0) {
        //     _vm.finished = true;
        // }

        // _vm.currentPage++;
    },
    procssData_myRelationship (_vm, dataList, isAdd) {
        if (isAdd) {
            for (let i = 0; i < dataList.length; i++) {
                _vm.itemList.push(dataList[i]);
            }
        }
        else {
            _vm.itemList = dataList;
        }

        _vm.loading = false;
        if (dataList.length <= 0) {
            _vm.finished = true;
        }
        else {
            _vm.finished = false;
        }
        _vm.currentPage++;
    },

    mark (_vm, id, favoriteType, isCancel) {
        if (_vm.buttonDisabled) {
            _vm.$toast("正在处理中...");
            return;
        }
        _vm.buttonDisabled = true;
        let dto = {
            RelationshipId: id,
            // FavoriteType: common.favoriteTypeEnum.Organization,
            FavoriteType: favoriteType,
            IsCancel: isCancel,
        };
        webService.addFavoriteRelationship(dto).then((res) => {
            console.log(res);
            if (res.data && res.data.success) {
                _vm.isMarked = !isCancel;
                let msg = isCancel ? "取消收藏" : "已收藏";
                _vm.$toast.success(msg);
            } else {
                _vm.$toast.fail(res.data.message);
            }
            _vm.buttonDisabled = false;
        });
    },
    batchDeleteMarked (_vm) {
        let listDel = _vm.list.filter((item) => item.checked);
        let arr = [];
        listDel.forEach(item => {
            arr.push(item.id)
        });
        webService.deleteFavoriteRelationship(arr).then((res) => {
            _vm.list = _vm.list.filter((item) => item.checked == false);
        });
    },
    batchDeleteMarked_Relation (_vm) {
        let listDel = _vm.itemList.filter((item) => item.checked);
        let arr = [];
        listDel.forEach(item => {
            arr.push(item.id)
        });
        webService.deleteFavoriteRelationship(arr).then((res) => {
            _vm.itemList = _vm.itemList.filter((item) => item.checked == false);
        });
    },
    batchDeleteMarked_News (_vm) {
        let listDel = _vm.itemList.filter((item) => item.checked);
        let arr = [];
        listDel.forEach(item => {
            arr.push(item.id)
        });
        webService.deleteFavoriteRelationship(arr).then((res) => {
            _vm.itemList = _vm.itemList.filter((item) => !item.checked);
        });
    },
    cancelMark (_vm, id) {
        webService.deleteFavoriteRelationship([id]).then((res) => {
            let idx = _vm.list.findIndex((item) => item.id == id);
            _vm.list.splice(idx, 1);
        });
    },
    cancelMark_relation (_vm, id) {
        webService.deleteFavoriteRelationship([id]).then((res) => {
            let idx = _vm.itemList.findIndex((item) => item.id == id);
            _vm.itemList.splice(idx, 1);
        });
    },
    addViewHistory (viewId, type) {
        let addDto = {
            ViewID: viewId,
            AddType: type,
        };
        webService.addViewHistory(addDto);
    },
    isEmpty (str) {
        return str == null || str == undefined || str === "";
    }
}


export class searchModel {

    constructor(searchType) {
        this.searchType = searchType;
    }

}


// WEBPACK FOOTER //
// ./src/common/common.js